import type { Session } from "@fluentry/domain";
import type { MobileSessionPayload } from "@fluentry/platform-adapters";
import type { MobileBridgeConfig } from "../lib/mobile-bridge";
import type { ProductAppAuthSessionData } from "../lib/auth-client";
import React from "react";

export type AuthSessionData = NonNullable<ProductAppAuthSessionData>;

type AppContextValue = {
  session: Session;
  authSession: AuthSessionData | null;
  mobileSession: MobileSessionPayload | null;
  isNativeSurface: boolean;
  mobileBridgeConfig: MobileBridgeConfig;
  mobileBridgeError: string | null;
  apiBaseUrl: string;
  refetchSession: () => Promise<void>;
  setMobileSession: (session: MobileSessionPayload | null) => Promise<void>;
  clearMobileBridgeError: () => void;
  openNativeBrowserSignIn: () => Promise<void>;
};

export const AppContext = React.createContext<AppContextValue | null>(null);

export function useAppContext(): AppContextValue {
  const ctx = React.useContext(AppContext);
  if (!ctx) throw new Error("useAppContext must be used within AppShell");
  return ctx;
}
